module.exports = __webpack_public_path__ + "static/img/org_title11.1291d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/org_title11.png
// module id = 29sJ
// module chunks = 4